import { IIconsProps } from "components/Icons/icons.model";

const BoxesStacked = (props: IIconsProps) => {
    return (
        <i id={props.id} className="fa-solid fa-boxes-stacked" style={{ fontSize: props.fontSize, color: props.color }} />
    );
};

export default BoxesStacked;
